var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stocks__items"},_vm._l((_vm.items),function(item){return _c('locale-router-link',{key:item.id,staticClass:"stocks__item",attrs:{"to":_vm.getComponent(item)}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
        _vm.$helpers.getAbsolutePath(
          item.attributes.preview_desktop.data.attributes.url
        )
      ),expression:"\n        $helpers.getAbsolutePath(\n          item.attributes.preview_desktop.data.attributes.url\n        )\n      "}],attrs:{"alt":"stock image","width":"380","height":"320"}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }